import { helper as buildHelper } from '@ember/component/helper';

/**
 * This will determine which side of activity feed to render the user image.
 *
 * @param params
 * @return {*}
 */
export function projectDetailsIsActivityItemOnLeft(params/*, hash*/) {
  let userViewing = params[0],
    activityItem = params[1];

  if (userViewing.get('isBuyer')) {
    // if user is a buyer all buyer events should be the left.
    return activityItem.get('user.isBuyer');
  }

  // user is a seller, so only seller users should be on left.
  return activityItem.get('user.isSeller');
}

export default buildHelper(projectDetailsIsActivityItemOnLeft);
